import { CommonArgs, InputBase } from "common/form/input/types/input-base";

export class DateTimeInput extends InputBase<string> {
	readonly initialHoursOffset?: number;
	readonly oldVersion?: boolean;
	constructor(args: DateTimeInputArgs) {
		super({
			key: args.key,
			value: args.value,
			type: "date_time",
			translateKey: args.translateKey,
			placeholderKey: args.placeholderKey,
			required: args.required,
			isCascading: args.isCascading,
			inputFieldType: "datetime-local",
		});
		this.initialHoursOffset = args.initialHoursOffset;
		this.oldVersion = args.oldVersion;
	}
}

export class DateTimeInputArgs extends CommonArgs<string> {
	placeholderKey?: string | null;
	initialHoursOffset?: number;
	oldVersion?: boolean = false;
}
